import PropTypes from 'prop-types';

import classNames from 'classnames/bind';

import CloseButton from '../CloseButton';
import BackButton from '../BackButton';

import styles from './ModalHeader.module.scss';

const cx = classNames.bind(styles);

const ModalHeader = ({
  className = '',
  titleClassName = '',
  backButtonClassName = '',
  label = '',
  subtitle = '',
  onRequestClose = () => {},
  onRequestBack = null,
  dataCy = '',
  dataTest = '',
  showBack = false,
  showClose = true
}) => {
  const modalHeaderClassName = cx(className, 'modal-header', {
    'modal-header--show-back': showBack
  });

  return (
    <div className={modalHeaderClassName}>
      {showBack && (
        <BackButton
          onClick={onRequestBack || onRequestClose}
          dataCy={dataCy}
          dataTest={dataTest}
          className={cx('modal-header__back-button', backButtonClassName)}
        />
      )}
      {(label || subtitle) && (
        <div className={cx('modal-header__title-block')}>
          {label ? (
            <h4 className={cx('modal-header__title', titleClassName)}>
              {label}
            </h4>
          ) : null}
          {subtitle ? (
            <p className={cx('modal-header__subtitle')}>{subtitle}</p>
          ) : null}
        </div>
      )}
      {showClose && (
        <CloseButton
          onClick={onRequestClose}
          dataCy={dataCy}
          dataTest={dataTest}
          className={cx('modal-header__close-button', backButtonClassName)}
        />
      )}
    </div>
  );
};

ModalHeader.propTypes = {
  className: PropTypes.string,
  titleClassName: PropTypes.string,
  backButtonClassName: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onRequestClose: PropTypes.func,
  onRequestBack: PropTypes.func,
  dataCy: PropTypes.string,
  dataTest: PropTypes.string,
  showBack: PropTypes.bool,
  showClose: PropTypes.bool
};

export default ModalHeader;
